module.exports = __webpack_public_path__ + "media/images/statistiky-bdbb4d96210a02c340057251d986689b.png";